import { Record } from 'immutable';

const keys: InvoiceFormFields = {
  firstName: '',
  lastName: '',
  addressLine1: '',
  addressLine2: '',
  zipCode: '',
  city: '',
  country: '',
  state: '',
  invoiceLanguage: '',
  email: '',
  contactNumber: '',
  vatNumber: '',
};

export interface InvoiceFormFields {
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  zipCode: string;
  city: string;
  country: string;
  state: string;
  invoiceLanguage: string;
  email: string;
  contactNumber: string;
  vatNumber: string;
}

export default class InvoiceFormRecord extends Record<InvoiceFormFields>(keys) {
  constructor(values?) {
    super(values);

    if (values && values.state === null) {
      return this.set('state', '');
    }
    return this;
  }
}
